import { Grid2, Typography } from "@mui/material";
import mission1 from "../../../ui-utils/photos/mission1.png";
import mission2 from "../../../ui-utils/photos/mission2.png";
import mission3 from "../../../ui-utils/photos/mission3.png";
import mission4 from "../../../ui-utils/photos/mission4.png";
import MissionWebViewStyles from "./MissionWebView.module.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import en from "../../../i18n/English/Aboutus/mission.json";
import hi from "../../../i18n/Hindi/Aboutus/mission.json";
import kn from "../../../i18n/Kannada/Aboutus/mission.json";
import ma from "../../../i18n/Marathi/Aboutus/mission.json";
import gu from "../../../i18n/Gujarati/Aboutus/mission.json";
import { useLanguage } from "../../../Context/LangContext";

export default function WebView() {
    const { language } = useLanguage();
    const translations = { en, hi, kn,gu,ma };
    const t = translations[language] || translations.en ;
  return (
    <>
      <Grid2
        sx={{
          width: "100%",
          overflowX: "hidden",
          boxSizing: "border-box",
          background: "#FFF6EE"

        }}
      >
        <Grid2 className={MissionWebViewStyles.miss_title_card}>
          {/* <h1 className={MissionWebViewStyles.miss_title}>

            {t.heading}
            </h1> */}
          <div className={MissionWebViewStyles.headingContainer}>
            <div className={MissionWebViewStyles.gradientBackground}></div>
            <Typography className={MissionWebViewStyles.miss_title} style={{ fontWeight: 600 }}>
                                        {t.heading}
                    </Typography>
                                </div>
        </Grid2>

        <Grid2 className={MissionWebViewStyles.miss_maincard}>

            <Grid2 className={MissionWebViewStyles.miss_outercard1}>

          {/* <AnimationOnScroll animateIn="animate__fadeInLeft"
            animateOnce={true}
            style={{ "--animate-duration": "0.5s" }}> */}
              <Grid2 className={MissionWebViewStyles.img_outercard1}>
                <Grid2 className={MissionWebViewStyles.img_card1}>
                  <img src={mission1} alt="aboutus"></img>
                </Grid2>
              </Grid2>
              <h3
                className={MissionWebViewStyles.about_title}
                style={{ marginTop: "3%" }}
              >
                {/* Remove complexities and adopt simple processes. */}
                {t.missions[0].title}
              </h3>

              <Typography className={MissionWebViewStyles.about_info}>
                {/* our mission is to empower investors with the most advanced
                technology platform and a highly simplified user interface, making
                every step of the investment process—from onboarding to
                settlement—effortless and secure. we eliminate complexities,
                empowering you to achieve your financial goals with ease." */}
              {t.missions[0].description}
              </Typography>

            </Grid2>

{/* </AnimationOnScroll> */}

         <Grid2 className={MissionWebViewStyles.miss_outercard2}>
            <Grid2 className={MissionWebViewStyles.img_outercard1}>
              <Grid2 className={MissionWebViewStyles.img_card2}>
                <img src={mission2} alt="aboutus2"></img>
              </Grid2>
            </Grid2>
            <h3
              className={MissionWebViewStyles.about_title}
              style={{ marginTop: "3%" }}
            >
              {/* Continuously Bring new investors into the market. */}
              {t.missions[1].title}
            </h3>
            <Typography className={MissionWebViewStyles.about_info}>
              {/* we are dedicated to continuously expanding the retail investor
              base in India's capital markets. By leveraging our expertise in
              stocks, bonds, mutual funds, and trading portals, we aim to
              attract new investors from diverse economic backgrounds. Our goal
              is to empower investors with knowledge, streamline access to
              finance, and maximize profits. */}
              {t.missions[1].description}
            </Typography>
          </Grid2>



          <Grid2 className={MissionWebViewStyles.miss_outercard3}>
            <Grid2 className={MissionWebViewStyles.img_outercard1}>
              <Grid2 className={MissionWebViewStyles.img_card3}>
                <img src={mission3} alt="aboutus3"></img>
              </Grid2>
            </Grid2>
            <h3
              className={MissionWebViewStyles.about_title}
              style={{ marginTop: "3%" }}
            >
              {/* Building social investor networks. */}
              {t.missions[2].title}
            </h3>
            <Typography className={MissionWebViewStyles.about_info}>
              {/* We are committed to building robust socio-investor networks that
              seamlessly connect the investor community with both Indian and
              global financial markets. Leveraging key insights and news, we
              bring together stock market enthusiasts, bond investors, and
              mutual fund traders. Our mission is to create a cohesive
              ecosystem, making financial information and opportunities
              accessible and engaging. */}

              {t.missions[2].description}
            </Typography>
          </Grid2>
          <Grid2 className={MissionWebViewStyles.miss_outercard4}>
            <Grid2 className={MissionWebViewStyles.img_outercard1}>
              <Grid2 className={MissionWebViewStyles.img_card4}>
                <img src={mission4} alt="aboutus4"></img>
              </Grid2>
            </Grid2>
            <h3
              className={MissionWebViewStyles.about_title}
              style={{ marginTop: "3%" }}
            >
              {/* Building an enlightened trading community */}
              {t.missions[3].title}
            </h3>
            <Typography className={MissionWebViewStyles.about_info}>
              {/* At Tradeboss, we believe that education and awareness are the
              cornerstones of successful investments. That’s why we offer
              "zero-cost" educational sessions, both online and offline, to
              cultivate a knowledgeable and enlightened trading community. With
              Tradeboss, you're not just investing; you're building a future
              with informed and confident financial decisions. */}
              {t.missions[3].description}
            </Typography>
          </Grid2>


        </Grid2>
      </Grid2>
    </>
  );
}
